import React from 'react';
import css from './css.module.less';
import {
  ModalContent,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { OriCheckbox, ModalFooter } from 'src/components/Antd';
const Group = OriCheckbox.Group;

const NavigationSelection = (props) => {
  const { navigationGroup, data, onConfirm, onCancel } = props;
  const currentData = (data || []).map((i) => i.uuid);
  const [selected, setSelected] = React.useState(currentData);
  const handleOnConfirm = () => {
    const previousSelected = (data || []).filter((i) =>
      selected.includes(i.uuid),
    );
    // console.log('previousSelected', previousSelected);
    const newSelected = selected.filter((i) => {
      return !currentData.includes(i);
    });
    //console.log('newSelected', newSelected);
    const mappedNewSelected = newSelected.map((uuid) => {
      const item = (navigationGroup || []).find((i) => i.uuid === uuid);
      const _item = { ...(item || {}), draggableId: uuid };
      return _item;
    });
    //console.log('mappedNewSelected', mappedNewSelected);

    const items = [...previousSelected, ...mappedNewSelected];
    if (onConfirm) onConfirm(items);
    onCancel();
  };
  return (
    <React.Fragment>
      <ModalContent>
        <Section size='small' className={css.container}>
          <Group
            value={selected}
            onChange={setSelected}
            className={css.group}
            options={(navigationGroup || []).map((i) => {
              const { uuid, title } = i;
              return { label: title, value: uuid };
            })}>
            {/* {(navigationGroup || []).map((i) => {
            const { uuid, name } = i;
            return (
              <OriCheckbox value={uuid} key={uuid} className={css.item}>
                {name}
              </OriCheckbox>
            );
          })} */}
          </Group>
        </Section>
      </ModalContent>
      <ModalFooter onOk={handleOnConfirm} onCancel={onCancel} />
    </React.Fragment>
  );
};
export default NavigationSelection;
